import type { FC, ReactNode } from "react";
import type { DateRange } from "react-day-picker";

import type { OptionItem, ResetOptionItem } from "@/api/admin";
import { CustomInput } from "@/components/atoms";
import { cn } from "@/lib/utils";

import DropDownFilterMenu, { type SubMenuItem } from "./DropDownFilterMenu";
import type { StatusVariants, SubMenuConfig } from "./types";

interface FilterSearchProps {
  menuList?: string[];
  subMenus?: Record<string, SubMenuItem[]>;
  statusVariant?: StatusVariants;
  classes?: string;
  children?: ReactNode;
  subMenuRegistry?: Record<string, SubMenuConfig>;
  searchValue: string;
  setSearchValue: (a: string) => void;
  handleSetFilter?: (selected: Record<string, string[] | OptionItem[]>) => void;
  isFilters?: boolean;
  initialSelectedMap?: Record<string, string[]>;
  initialSelectedObjectMap?: Record<string, OptionItem[]>;
  initialMetaMap?: Record<
    string,
    | DateRange
    | {
        from?: string;
        to?: string;
      }
  >;
  resetObject?: ResetOptionItem;
  childrenClasses?: string;
}

const FilterSearch: FC<FilterSearchProps> = ({
  menuList,
  subMenus,
  statusVariant,
  classes,
  children,
  subMenuRegistry,
  searchValue,
  setSearchValue,
  handleSetFilter,
  isFilters = true,
  initialSelectedMap = {},
  initialSelectedObjectMap = {},
  initialMetaMap = {},
  resetObject,
  childrenClasses,
}) => {
  return (
    <div
      className={cn(
        "flex items-center gap-5 md:gap-[9px] items-start mt-8 mb-4 md:mb-8 flex-wrap md:flex-nowrap flex-col md:flex-row",
        classes
      )}
    >
      <div className="flex items-center w-full flex-wrap gap-2">
        <CustomInput
          placeholder="Search"
          type="text"
          className="h-8 w-[300px]"
          data-testid="filter-search-input"
          value={searchValue}
          onChange={e => setSearchValue(e.target.value)}
        />
        {isFilters && (
          <DropDownFilterMenu
            menuList={menuList ?? []}
            subMenus={subMenus ?? {}}
            statusVariant={statusVariant}
            subMenuRegistry={subMenuRegistry ?? {}}
            handleSetFilter={handleSetFilter}
            initialSelectedMap={initialSelectedMap}
            initialSelectedObjectMap={initialSelectedObjectMap}
            initialMetaMap={initialMetaMap}
            resetObject={resetObject}
          />
        )}
      </div>
      <div
        className={cn(
          "flex items-center self-end md:self-auto",
          childrenClasses
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default FilterSearch;
